import Gameplay from "slotworks/model/gameplay/gameplay";
import { RecordBuilder } from "slotworks/server/builders/record-builder";
import { AuthRecordBuilder } from "ags/integration/builders/records/auth-record-builder";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import bonusSymbolSetup from "utils/bonus-symbol-setup";
import { addValueToExistingMCSymbols } from "utils/mc-symbol-grid-conversions";
import { MCAnticipationSchema } from "integration/schema/mc-auth-response-schema";

class CGAuthRecordBuilder extends AuthRecordBuilder implements RecordBuilder {

    public id: string = "CGSAuthRecordBuilder";

    public build(gameplay: Gameplay, request: any, response: any) {
        const record = super.build(gameplay, request, response).pop() as SpinRecord;
        const authResponse = JSON.parse(response.data).publicState as MCAnticipationSchema;

        bonusSymbolSetup.setAnticipationSymbols(authResponse.stakes.availableStakes, authResponse.anticipationSymbols);

        // TODO: Enable once server has a default stake.
        // record.grid = addValueToExistingMCSymbols(record.grid);

        return [record];
    }
}

export default new CGAuthRecordBuilder();
